import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface AccountNumberBrand {
    readonly AccountNumber: unique symbol;
}

export const AccountNumber = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, AccountNumberBrand> => /^\d{7,25}$/.test(n),
    'AccountNumber'
);

export type AccountNumber = TypeOf<typeof AccountNumber>;
